"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["CART_CREATED"] = "cart.created";
    EventType["CART_DELETED"] = "cart.deleted";
    EventType["CART_ITEM_CREATED"] = "cart.item.created";
    EventType["CART_ITEM_DELETED"] = "cart.item.deleted";
    EventType["CART_ITEM_UPDATED"] = "cart.item.updated";
    EventType["CART_SHIPPING_CREATED"] = "cart.shipping.created";
    EventType["CART_SHIPPING_UPDATED"] = "cart.shipping.updated";
    EventType["CART_UPDATED"] = "cart.updated";
    EventType["CLIENT_CREATED"] = "client.created";
    EventType["CLIENT_DELETED"] = "client.deleted";
    EventType["CLIENT_UPDATED"] = "client.updated";
    EventType["CREDIT_MEMO_CREATED"] = "credit.memo.created";
    EventType["CUSTOMER_CREATED"] = "customer.created";
    EventType["CUSTOMER_DELETED"] = "customer.deleted";
    EventType["CUSTOMER_UPDATED"] = "customer.updated";
    EventType["INVOICE_CREATED"] = "invoice.created";
    EventType["ORDER_CREATED"] = "order.created";
    EventType["ORDER_PLACED"] = "order.placed";
    EventType["ORDER_SHIPMENT_CREATED"] = "order.shipment.created";
    EventType["ORDER_SHIPMENT_UPDATED"] = "order.shipment.updated";
    EventType["ORDER_UPDATED"] = "order.updated";
    EventType["PAYMENT_METHOD_CREATED"] = "payment.method.created";
    EventType["PAYMENT_METHOD_DELETED"] = "payment.method.deleted";
    EventType["PAYMENT_METHOD_UPDATED"] = "payment.method.updated";
    EventType["PERMISSION_CREATED"] = "permission.created";
    EventType["PERMISSION_DELETED"] = "permission.deleted";
    EventType["PERMISSION_UPDATED"] = "permission.updated";
    EventType["PRODUCT_CREATED"] = "product.created";
    EventType["PRODUCT_DELETED"] = "product.deleted";
    EventType["PRODUCT_INVENTORY_CREATED"] = "product.inventory.created";
    EventType["PRODUCT_INVENTORY_UPDATED"] = "product.inventory.updated";
    EventType["PRODUCT_UPDATED"] = "product.updated";
    EventType["PRODUCT_VAT_MODIFIED"] = "product.vat.modified";
    EventType["PRODUCT_VAT_UPDATED"] = "product.vat.updated";
    EventType["PROMOTION_CREATED"] = "promotion.created";
    EventType["PROMOTION_DELETED"] = "promotion.deleted";
    EventType["PROMOTION_UPDATED"] = "promotion.updated";
    EventType["RECEIPT_CREATED"] = "receipt.created";
    EventType["ROLE_CREATED"] = "role.created";
    EventType["ROLE_DELETED"] = "role.deleted";
    EventType["ROLE_UPDATED"] = "role.updated";
    EventType["SHIPPING_CREATED"] = "shipping.created";
    EventType["SHIPPING_DELETED"] = "shipping.deleted";
    EventType["SHIPPING_UPDATED"] = "shipping.updated";
    EventType["SHIPPING_VAT_UPDATED"] = "shipping.vat.updated";
    EventType["TAX_GROUP_CREATED"] = "tax.group.created";
    EventType["TAX_GROUP_DELETED"] = "tax.group.deleted";
    EventType["TAX_GROUP_UPDATED"] = "tax.group.updated";
    EventType["TAX_RATE_CREATED"] = "tax.rate.created";
    EventType["TAX_RATE_DELETED"] = "tax.rate.deleted";
    EventType["TAX_RATE_UPDATED"] = "tax.rate.updated";
    EventType["TAXONOMY_CREATED"] = "taxonomy.created";
    EventType["TAXONOMY_DELETED"] = "taxonomy.deleted";
    EventType["TAXONOMY_UPDATED"] = "taxonomy.updated";
    EventType["USER_CREATED"] = "user.created";
    EventType["USER_DELETED"] = "user.deleted";
    EventType["USER_UPDATED"] = "user.updated";
    EventType["VAT_CREATED"] = "vat.created";
    EventType["VAT_DELETED"] = "vat.deleted";
    EventType["VAT_MODIFIED"] = "vat.modified";
    EventType["VAT_REMOVED"] = "vat.removed";
    EventType["VAT_UPDATED"] = "vat.updated";
    EventType["ZONE_CREATED"] = "zone.created";
    EventType["ZONE_DELETED"] = "zone.deleted";
    EventType["ZONE_UPDATED"] = "zone.updated";
})(EventType = exports.EventType || (exports.EventType = {}));
//# sourceMappingURL=events.js.map